module.exports = __webpack_public_path__ + "static/audi-s4-front-grill-grey-allstocksociety-600px-e2c1b6986820065d9acc22a3b831bdee.jpg";